var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Gallery',{attrs:{"title":"Hosting the World","subtitle":"Events","images":[
    {
        title:'SOFI Stadium',
        file:'events.jpg'
    }
    ]}}),_c('Events'),_c('Linear',{attrs:{"forcedPath":"/champion-la/why-champion-la","forcedTitle":"Why ChampionLA?"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }